import { makeStyles } from '@material-ui/core';
import { PageLayout, Table, useAuthenticatedUser } from '@ngt/opms';
import { Permission, usePermissionsByIds } from '@ngt/opms-bctapi';
import { Column } from 'material-table';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { IReportParam, ReportExportFormat, createReportUrl } from '../utils/createReportUrl';
import { useContext } from 'react';
import ReportSettingsContext from '../contexts/ReportSettingsContext';

interface IReportsProps {
    institutionCode?: string
}

export interface IReportItem {
    reportType: number;
    reportTitle: string;
    reportIdentifier: string;
    reportParams?: IReportParam[];
    reportFormat?: ReportExportFormat;
}

const useStyles = makeStyles(theme => ({
    container: {
        padding: theme.spacing(3),
        display: 'flex',
        gap: 50
    },
    tableWrapper: {
        width: '100%'
    }
}));

const SSRS_REPORT = 1;
const OPMS_REPORT = 2;

const drugManagementPermissions: Permission[] = [
    Permission.DrugManagementView
];

const permissions: Permission[] = [
    Permission.OpmsAdminister
];

const Reports: React.FunctionComponent<IReportsProps> = () => {
    const classes = useStyles();

    const history = useHistory();

    const [user] = useAuthenticatedUser();

    const [[canViewDrugManagement],] = usePermissionsByIds(drugManagementPermissions, null, null, null, null, false);

    const [[canAdministerOpms],] = usePermissionsByIds(permissions, null, null, null, null, false);

    const reportSettings = useContext(ReportSettingsContext)

    const onOpmsReportClick = React.useCallback((report?: IReportItem | undefined) => {
        if (report) {
            history.push(`/${report.reportIdentifier}`);
        }
    }, [history]);

    const onSsrsReportClick = React.useCallback((report?: IReportItem | undefined) => {
        if (report) {
            const reportUrl: string = createReportUrl(reportSettings,
                report.reportIdentifier,
                report?.reportParams ?? [],
                report.reportFormat ? report.reportFormat as unknown as ReportExportFormat : undefined,
                true);

            window.open(reportUrl);
        }
    }, [reportSettings]);

    //@ts-expect-error
    const onRowClick = React.useCallback((event?: React.MouseEvent<Element, MouseEvent>, row?: IReportItem | undefined) => {
        if (row?.reportType === SSRS_REPORT) {
            onSsrsReportClick(row);
        } else if (row?.reportType === OPMS_REPORT) {
            onOpmsReportClick(row);
        }
    }, [onSsrsReportClick, onOpmsReportClick]);

    const reportColumns = React.useMemo(() => {
        const columns: Array<Column<IReportItem>> = [
            {
                title: 'Reports',
                field: 'reportTitle',
            }
        ];

        return columns;
    }, []);

    const reports = React.useMemo(() => {
        return [
            // !!canViewEcrf && {
            //     reportType: SSRS_REPORT,
            //     reportTitle: 'Forms Due Schedule',
            //     reportIdentifier: 'FormsDueSchedule',
            //     reportParams: [
            //         { paramName: 'UserKey', paramValue: user?.userName }
            //     ]
            // },
            //!!canViewEcrf && {
            //    reportType: OPMS_REPORT,
            //    reportTitle: 'Forms Due Summary',
            //    reportIdentifier: 'forms-due-summary'
            //},
            //!!canViewEcrf && {
            //    reportType: SSRS_REPORT,
            //    reportTitle: 'Forms Due Summary',
            //    reportIdentifier: 'FormsDueSummary',
            //    reportParams: [
            //        { paramName: 'UserKey', paramValue: user?.userName },
            //        { paramName: 'Institution', paramValue: '-1' },
            //        { paramName: 'Patient', paramValue: '-1' }
            //    ]
            //},
            //!!canViewEcrf && {
            //    reportType: SSRS_REPORT,
            //    reportTitle: 'Forms Overdue',
            //    reportIdentifier: 'FormsOverdue',
            //    reportParams: [
            //        { paramName: 'UserKey', paramValue: user?.userName },
            //        { paramName: 'Institution', paramValue: '-1' },
            //        { paramName: 'Patient', paramValue: '-1' }
            //    ]
            //},
            !!canViewDrugManagement && {
               reportType: SSRS_REPORT,
               reportTitle: 'Batch Report',
               reportIdentifier: 'BatchReport',
               reportParams: [
                   { paramName: 'UserKey', paramValue: user?.userName }
               ]
            },
            !!canAdministerOpms && {
               reportType: SSRS_REPORT,
               reportTitle: 'Depot Stock',
               reportIdentifier: 'DepotStock',
               reportParams: [
                   { paramName: 'UserKey', paramValue: 'EmailLink' }
               ]
            },
            !!canViewDrugManagement && {
               reportType: SSRS_REPORT,
               reportTitle: 'Drug Management Log',
               reportIdentifier: 'DrugManagementLog',
               reportParams: [
                   { paramName: 'UserKey', paramValue: user?.userName }
               ]
            },
            !!canViewDrugManagement && {
               reportType: SSRS_REPORT,
               reportTitle: 'Drug Shipment Report',
               reportIdentifier: 'DrugShipmentReport',
               reportParams: [
                   { paramName: 'UserKey', paramValue: user?.userName }
               ]
            },
            //!!canAdministerOpms && {
            //    reportType: SSRS_REPORT,
            //    reportTitle: 'Monthly SAE Report',
            //    reportIdentifier: 'MonthlySaeReport',
            //},
            !!canViewDrugManagement && {
               reportType: SSRS_REPORT,
               reportTitle: 'Patient Action Report',
               reportIdentifier: 'PatientActionReport',
               reportParams: [
                   { paramName: 'UserKey', paramValue: user?.userName }
               ]
            },
            !!canAdministerOpms && {
               reportType: SSRS_REPORT,
               reportTitle: 'Abema Report',
               reportIdentifier: 'AbemaReport',
               reportParams: [
                    { paramName: 'Token', paramValue: 'EmailLink' }
               ]
            },
        ].filter(x => !!x) as IReportItem[];
        //].filter(x => !!x)?.sort((a: IReportItem, b: IReportItem) => a.reportTitle < b.reportTitle ? -1 : 1) as IReportItem[];
    }, [canViewDrugManagement, canAdministerOpms, user]);

    return (
        <PageLayout
        >
            <div
                className={classes.container}
            >
                <div
                    className={classes.tableWrapper}
                >
                    <Table
                        data={reports}
                        columns={reportColumns}
                        onRowClick={onRowClick}
                        title="Reports"
                        components={{
                            Header: () => <></>
                        }}
                        options={{
                            paging: reports.length > 10,
                            pageSize: 10,
                        }}
                    />
                </div>
            </div>
        </PageLayout>
    );
};

export default Reports;
